"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var StatsigContext_1 = __importDefault(require("./StatsigContext"));
function default_1() {
    var context = (0, react_1.useContext)(StatsigContext_1.default);
    return context.updateUser;
}
exports.default = default_1;
